"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTableSelection = void 0;

var _react = require("react");

var _Selection = _interopRequireDefault(require("../renderers/Selection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useTableSelection = function useTableSelection(rowSelection) {
  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedRowKeys = _useState2[0],
      setSelectedRowKeys = _useState2[1];

  var hasSelection = (0, _react.useMemo)(function () {
    return rowSelection !== null;
  }, []);
  (0, _react.useEffect)(function () {
    if (rowSelection && rowSelection.selectedRowKeys) {
      setSelectedRowKeys(rowSelection.selectedRowKeys);
    }
  }, [rowSelection ? rowSelection.selectedRowKeys : null]);

  var onChangeSelection = function onChangeSelection(key) {
    var newState = [key];

    if (rowSelection.type === 'checkbox') {
      if (selectedRowKeys.includes(key)) {
        newState = selectedRowKeys.filter(function (item) {
          return item !== key;
        });
      } else {
        newState = [].concat(_toConsumableArray(selectedRowKeys), [key]);
      }
    }

    setSelectedRowKeys(newState);
    if (typeof rowSelection.onChange === 'function') rowSelection.onChange(newState);
  };

  var selectionType = (0, _react.useMemo)(function () {
    return hasSelection ? rowSelection.type || 'radio' : null;
  }, [hasSelection, rowSelection ? rowSelection.type : null]);
  var selectionConfig = (0, _react.useMemo)(function () {
    return selectionType ? {
      selectedRowKeys: selectedRowKeys,
      render: (0, _Selection.default)({
        type: selectionType,
        selectedRowKeys: selectedRowKeys,
        onChange: onChangeSelection
      })
    } : {};
  }, [selectionType, selectedRowKeys, onChangeSelection]);
  return {
    selectionConfig: selectionConfig
  };
};

exports.useTableSelection = useTableSelection;